<!-- Toolbar Overrides Title-->
@if ((orderContext$ | async).order; as order) {
  <ng-template elderToolbarColumn="left">
    <elder-header
      [header]="('orders.work.order' | translate) + ' ' + order.id"
      [subheader]="order.projectDescription + ' / ' + order.description"
    >
    </elder-header>
  </ng-template>
}

<!-- Toolbar Overrides Actions -->
@if ((orderContext$ | async).order; as order) {
  <ng-template elderToolbarColumn="right.actions">
    <div class="layout-row place-start-center">
      <app-entity-link
        [entityType]="'order'"
        [entityId]="order.prodOrderId"
        [company]="order.company"
      >
      </app-entity-link>
    </div>
  </ng-template>
}

<div class="layout-col full">
  @if ((orderContext$ | async).order; as order) {
    <app-work-order-full [workOrder]="order" class="flex"></app-work-order-full>
  }

  <!-- Fallback when order is not available -->
  @if (orderContext$ | async; as orderContext) {
    @if (!orderContext.order) {
      @if (orderContext.error) {
        <elder-single-pane-wrapper class="flex">
          <elder-pane-header>
            <elder-pane-title>
              <span>{{ 'context.order' | translate }} {{ orderContext.orderNumber }}</span>
            </elder-pane-title>
          </elder-pane-header>
          <elder-pane-content>
            <div class="layout-row place-start-center gap-sm">
              <mat-icon color="warn">warning</mat-icon>
              <span>{{ orderContext.error }}</span>
            </div>
          </elder-pane-content>
        </elder-single-pane-wrapper>
      }
    }
  }
</div>
